import {
  authorizations,
  createErrorMessage,
  createSuccessMessage,
  serviceBase
} from "../service";
import api from "../api";

const Project = {
  ...serviceBase,
  resource: "projects",
  resourceRole: "project",
  preList: function(params, action) {
    if (action === "create") return `organizations/${params.organization_id}`;
    if (action === "getList")
      return params.organization_id
        ? `organizations/${params.organization_id}`
        : "me";
  },
  preListOption: {
    create: true,
    getList: true
  },
  terminate(params = {}, onSuccess = () => {}, onError = () => {}) {
    params = api.helpers.clearResource(params);
    let preList = this.getPreList("delete", params);
    return api
      .post(
        `${preList ? "/" + preList : ""}/${this.resource}/${
          params.id
        }:terminate`,
        params
      )
      .then(res => {
        createSuccessMessage("terminate");
        onSuccess(res.data);
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        onError(res);
      });
  },
  cancelTermination(params = {}, onSuccess = () => {}, onError = () => {}) {
    params = api.helpers.clearResource(params);
    let preList = this.getPreList("delete", params);
    return api
      .post(
        `${preList ? "/" + preList : ""}/${this.resource}/${
          params.id
        }:cancelTermination`,
        params
      )
      .then(res => {
        createSuccessMessage("cancel-termination");
        onSuccess(res.data);
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        onError(res);
      });
  }
};
Project.authorizations = authorizations(Project);
export default Project;
